(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/lastmatches-collection.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/lastmatches-collection.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.collections.LastMatches = Backbone.Collection.extend({
    log: new svs.core.log.Logger('svs.collections.Matchlist'),
    model: svs.tipset.models.LastMatch,

    getPath: function() {
      var lastMatchesPath,
        lastMatchesArr = [],
        self = this;
      _.each(svs.tipset.collections.matchlist.getAllMatches(), function(match) {
        if (!match.get('isPlayer')) {
          lastMatchesArr.push(
            '/sport/1/teams/' +
              match.get('match').participants[0].id +
              '/lastmatches?count=5'
          );
          lastMatchesArr.push(
            '/sport/1/teams/' +
              match.get('match').participants[1].id +
              '/lastmatches?count=5'
          );
          self.add(
            new svs.tipset.models.LastMatch(
              match.get('match').participants[0].id
            )
          );
          self.add(
            new svs.tipset.models.LastMatch(
              match.get('match').participants[1].id
            )
          );
        }
      });

      lastMatchesPath = lastMatchesArr.join('|');

      return lastMatchesPath;
    },

    url: function() {
      svs.events.publish('/loader/show');
      var newUrl = '/multifetch?urls=' + encodeURIComponent(this.getPath());

      return svs.core.jupiter.url() + newUrl;
    },

    parse: function(response) {
      _.each(this.models, function(match, index) {
        if (
          response &&
          response.responses &&
          response.responses[index] &&
          response.responses[index].result
        ) {
          match.setLastMatchValues(response.responses[index].result);
        }
      });
      this.trigger('lastMatchesReady');
    },

    getLastMatchesByTeamId: function(id) {
      return this.findWhere({ teamId: id });
    }
  });
})(Backbone, _, svs);

 })(window);